"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var checkProp = function checkProp(obj, prop) {
  if (!obj || !prop) {
    return false;
  }
  return Object.prototype.hasOwnProperty.call(obj, prop) ? obj[prop] : null;
};
var defaultValidation = function defaultValidation(val) {
  return val && val.length > 0;
};
function TextEditComponent(_ref) {
  var data = _ref.data,
    classes = _ref.classes,
    customOptions = _ref.customOptions,
    onSave = _ref.onSave,
    editTool = _ref.editTool;
  var _react$default$useSta = _react.default.useState(data || ''),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    value = _react$default$useSta2[0],
    setValue = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    editActivated = _react$default$useSta4[0],
    setEditActivated = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState(''),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    formerValue = _react$default$useSta6[0],
    setFormerValue = _react$default$useSta6[1];
  var _react$default$useSta7 = _react.default.useState({
      value: false,
      message: ''
    }),
    _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
    error = _react$default$useSta8[0],
    setError = _react$default$useSta8[1];
  var handleChange = function handleChange(event) {
    if (event && event.target.value) {
      setValue(event.target.value);
      return;
    }
    setValue('');
  };
  var handleEdit = function handleEdit() {
    var disabled = checkProp(customOptions, 'disabled');
    if (!editActivated && !disabled) {
      setFormerValue(value);
      setEditActivated(true);
    }
  };
  var handleSave = function handleSave() {
    var validationEnabled = checkProp(customOptions, 'validationEnabled');
    var validation = checkProp(customOptions, 'validation');
    var errorFound = false;
    setEditActivated(false);
    if (validationEnabled) {
      if (validation && typeof validation === 'function') {
        errorFound = validation(value);
      } else {
        errorFound = defaultValidation(value);
      }
    }
    setError({
      value: errorFound,
      message: errorFound ? 'please enter value prior to saving.' : ''
    });
    if (!error.value && onSave && typeof onSave === 'function') {
      onSave(value, customOptions.field);
    }
  };
  var handleCancel = function handleCancel() {
    setValue(formerValue);
    setEditActivated(false);
  };
  var useLargerField = checkProp(customOptions, 'useLargerField');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textField
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    error: error.value,
    value: value,
    className: "".concat(useLargerField ? classes.textField_ex : ''),
    onChange: handleChange,
    InputProps: {
      classes: {
        input: classes.inputFont
      },
      endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
        position: "start",
        onClick: handleEdit
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: classes.editIcon,
        src: editTool.src,
        alt: checkProp(customOptions, 'alt') || 'edit'
      })),
      readOnly: !editActivated
    },
    helperText: error.message
  }), editActivated ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btnSave,
    variant: "contained",
    onClick: handleSave
  }, "Save"), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btnCancel,
    variant: "text",
    onClick: handleCancel
  }, "Cancel")) : '');
}
var styles = function styles() {
  return {
    textField: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      flex: 2,
      fontWeight: 'bold',
      color: '#7b858f',
      minWidth: '70%'
    },
    textField_ex: {
      minWidth: '75%'
    },
    btnEdit: {
      minWidth: '34px',
      padding: 0,
      margin: '0 5px'
    },
    editIcon: {
      width: '14px',
      cursor: 'pointer'
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      alignSelf: 'center'
    },
    btnCancel: {
      padding: 0,
      minWidth: '50px',
      margin: '0 5px',
      lineHeight: '1.5em',
      height: '26px'
    },
    btnSave: {
      padding: 0,
      minWidth: '50px',
      margin: '0 5px 0 10px',
      lineHeight: '1.5em',
      height: '26px',
      backgroundColor: '#375fac',
      color: '#ffffff',
      '&:hover': {
        color: '#000000'
      }
    },
    inputFont: {
      color: '#525f6b',
      fontWeight: 'bold',
      padding: '5px 0 5px 10px'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(TextEditComponent);
exports.default = _default;